import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import HourlySalesReportView from './HourlySalesReportView';
import HourlySalesReportFromInvoiceView from './HourlySalesReportFromInvoiceView';

const HourlySalesReport = () => {
    const dataMode = localStorage.getItem("dataMode");
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Hourly Sales Report" mainTitle="Hourly Sales Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {dataMode === "invoicewise" ? <HourlySalesReportFromInvoiceView /> : <HourlySalesReportView />}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default HourlySalesReport
